import type { ApiClient } from "./client";
import type { ProjectListItem, ProjectsResponse } from "./types";

export async function listProjects(client: ApiClient): Promise<ProjectListItem[]> {
  const r = await client.get<ProjectsResponse>("/projects");
  return r.projects;
}
